import { TableTemplate } from "components/templates/default/table/TableTemplate";
import AddGroupsModal from "../add/groups";
import Status, { StatusType } from "components/blocks/status/Status";
import { ClickSearch } from "components/atoms/input/search/SearchInput";
import { BasePagination } from "api/interfaces/commonInterface.interface";
import { TableColumnsType } from "antd";
import { CommonTable } from "components/atoms/table/AntdTable";
import { RecorderGroup } from "api/interfaces/recorderInterface.interface";

type Props = {
  isAddModal: boolean;
  isEditModal: boolean;
  onModal: (type: string) => void;
  columns: TableColumnsType<RecorderGroup>;
  status: StatusType;
  data: Array<RecorderGroup>;
  selectGroup?: RecorderGroup;
  onClickEdit: (row: RecorderGroup) => void;
  onChangePage: (page: number, totalRows: number) => void;
  onClickSearch: ClickSearch;
  paginationInfo: BasePagination;
  totalRows: number | undefined;
  isRowClickEditable: boolean;
  initialPending: boolean;
  onSuccessDelete: () => void;
};

export default function GroupPresenter({
  isAddModal,
  isEditModal,
  onModal,
  columns,
  status,
  data,
  selectGroup,
  paginationInfo,
  onClickEdit,
  onChangePage,
  onClickSearch,
  isRowClickEditable,
  initialPending,
  onSuccessDelete,
}: Props): JSX.Element {
  const centerChildren = <Status status={status} />;

  return (
    <>
      <TableTemplate
        onClickBtn={() => onModal("add")}
        buttonLabel="Add Groups"
        centerChildren={centerChildren}
        onClickSearch={onClickSearch}
        requiredPermissions="manageRecordersAndGroups"
        keyword={paginationInfo.keyword}
        data-testid="recorders-groups-groups-table-template-modal"
      >
        <CommonTable
          columns={columns}
          dataSource={data}
          queryInfo={paginationInfo}
          onChangePage={onChangePage}
          loading={initialPending}
          rowKey="id"
        />
      </TableTemplate>
      {isAddModal && <AddGroupsModal onModal={() => onModal("add")} />}
      {isEditModal && (
        <AddGroupsModal
          isEditModal={isEditModal}
          selectGroup={selectGroup}
          onModal={() => onModal("edit")}
          onSuccessDelete={onSuccessDelete}
        />
      )}
    </>
  );
}
